import styled, { th } from '@xstyled/styled-components'
import { Dropdown } from '../dropdown/dropdown'

export const StyledDropdown = styled(Dropdown)({
  width: '100%',
  '.dropdown-container': {
    zIndex: 1000,
    overflow: 'visible',
    width: 'max-content',
    padding: '4px',
    borderRadius: 'md',
    boxShadow: 'md'
  }
})

export const StyledDropdownItem = styled(Dropdown.Item)({
  justifyContent: 'center',
  height: '32px',
  width: '32px',
  padding: 0,
  borderRadius: 'md',
  '&:hover, &:focus': {
    background: `${th.color('grey.l3')}`
  }
})
